export const rateType = {
  spot: "spot",
  contract: "contract",
};
